import { EditOutlined } from '@mui/icons-material';
import { IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

interface Props {
  title: string;
  titleAdornment?: React.ReactNode;
  editButtonId: string;
  onEditClick: () => void;
  spacing: number;
  children: React.ReactNode;
}

const EditableCard: React.FC<Props> = ({ title, titleAdornment, editButtonId, onEditClick, spacing, children }) => {
  const { translation } = useTranslation();

  return (
    <Paper elevation={3} sx={{ padding: '24px', borderRadius: 1, width: '100%' }}>
      <Stack spacing={spacing}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <Stack direction="row" alignItems="center" minWidth={0} flexGrow={1}>
            <Typography variant="h5">{title}</Typography>
            {titleAdornment}
          </Stack>
          <Tooltip title={translation.edit}>
            <IconButton onClick={onEditClick} id={editButtonId} aria-label={translation.edit} sx={{ padding: '4px' }}>
              <EditOutlined />
            </IconButton>
          </Tooltip>
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};

export default EditableCard;
